/**
 * Opens the cart drawer after a donation is added to the cart.
 *
 * The store keeps "automatically open the cart drawer" switched off, which is
 * right for the furniture shop — you add a chair and carry on browsing. It is
 * wrong for a gift: the donor clicks "Give £25", sees a tick and a badge, and
 * leaves believing they have donated when no money has moved. So the donation
 * forms opt in on their own, and shop behaviour is left alone.
 *
 * The listener goes on each donation form rather than on the document, because
 * the cart event's `sourceId` is the variant id, not the element id — there is
 * nothing on the event that distinguishes a donation. The form the event was
 * dispatched from is the reliable signal.
 */
const DONATION_FORM_SELECTOR = 'product-form-component[data-cs-donation]';

/** @param {Event} event */
function openCartDrawer(event) {
  if (/** @type {CustomEvent} */ (event).detail?.data?.didError) return;

  const drawer = document.querySelector('cart-drawer-component');
  // Already handled globally when auto-open is on — don't open it twice.
  if (!drawer || drawer.hasAttribute('auto-open') || typeof drawer.open !== 'function') return;

  drawer.open();
}

function watchDonationForms(root = document) {
  for (const form of root.querySelectorAll(DONATION_FORM_SELECTOR)) {
    if (form.dataset.csDonationWatched) continue;
    form.dataset.csDonationWatched = 'true';
    form.addEventListener('cart:update', openCartDrawer);
  }
}

watchDonationForms();

// Sections are re-rendered in the theme editor, and by the cart itself.
document.addEventListener('shopify:section:load', (event) => {
  const target = /** @type {CustomEvent} */ (event).target;
  if (target instanceof Element) watchDonationForms(target);
});
